import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export type TAssignmentForm = {
  resourceId: number
  crewSize: number
  duration: number
  startTime: Date
  assigneeIds?: number[] | undefined
}

export function useAssignmentsForm() {
  function getResolvedAssignmentsSchema(duration: number) {
    const validationSchema = z.object({
      resourceId: z.coerce
        .number({ invalid_type_error: 'Please, select a Resource' })
        .min(0, { message: 'Please, select a resource' }),
      crewSize: z
        .union([z.string(), z.number()])
        .transform((val) =>
          String(val).length === 0 ? '' : val === '0' ? 0 : Number(val),
        )
        .refine((val) => typeof val !== 'string', {
          message: 'Please, add the crew size for this task',
        })
        .refine((val) => Number(val) >= 0, {
          message: 'Value must be greater or equal to 0',
        }),

      duration: z
        .union([z.string(), z.number()])
        .transform((val) =>
          String(val).length === 0 ? '' : val === '0' ? 0 : Number(val),
        )
        .refine((val) => typeof val !== 'string', {
          message: 'Please, add the duration for this task',
        })
        .refine((val) => Number(val) <= duration && Number(val) >= 0, {
          message: 'Value must be less than or equal to the task duration',
        }),

      startTime: z.date(),
      assigneeIds: z.number().array().optional(),
    })

    return zodResolver(validationSchema)
  }

  return { getResolvedAssignmentsSchema }
}
